import React from 'react';
import PropTypes from 'prop-types';

import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import {styled} from '@mui/system';


const StyledTabContent = styled(Paper)(({ theme }) =>({
    paddingLeft: theme.custom.paper.side_space,
    paddingRight: theme.custom.paper.side_space,
    paddingTop: theme.custom.paper.top_space,
    paddingBottom: theme.custom.paper.bottom_space,
    marginBottom: 30,
    minWidth: theme.custom.min_width
}));

const StyledTab = styled(Tab)({
    minWidth: 150
});


class ContentTabs extends React.Component {
    /*
    Requires a configuration object in the form:
    tabs: [
        {
            label: 'Tab label',
            content: callable returning react component or string
        },
        ...
    ]
     */
    constructor(props) {
        super(props);
        this.state = {
            selected_tab : this.props.default || 0
        };
    }

    tabProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `tab-content-${index}`
        };
    };

    handleTabSelection = (event, newValue) => {
        this.setState({selected_tab: newValue});
    };

    render() {
        return (
            <div>
                <AppBar position="static" color="default">
                    <Tabs value={this.state.selected_tab} onChange={this.handleTabSelection}>
                         {this.props.tabs.map((tab, index) => <StyledTab label={tab.label} key={`tab_${index}`} {...this.tabProps(index)} />)}
                    </Tabs>
                </AppBar>
                <StyledTabContent>
                    {this.props.tabs.map((tab, index) =>
                    <Typography
                        component="div"
                        role="tabpanel"
                        hidden={this.state.selected_tab !== index}
                        key={`tab-content-${index}`}
                        id={`tab-content-${index}`}
                        aria-labelledby={`simple-tab-${index}`}
                    >
                        {this.state.selected_tab === index && tab.content()}
                    </Typography>
                )}
                </StyledTabContent>
            </div>
        );
    }
}

ContentTabs.propTypes = {
    tabs: PropTypes.array.isRequired,
    default: PropTypes.number
};


export default ContentTabs;
